module.exports = __webpack_public_path__ + "files/31ae13e578bc6d208435f85f41b27efa.png";